/**
 * URL-safe id obfuscation for the public web app.
 *
 * Mirrors `apps/panel/src/utils/idCodec.ts` so /shop/:id URLs (and any
 * future customer-facing detail pages) don't leak the raw product
 * UUID. This is OBFUSCATION not encryption — anyone with DevTools
 * can recover the id, but it stops the address bar from broadcasting
 * primary keys to anyone glancing at the screen.
 */

export function encodeId(id: string | number | null | undefined): string {
  if (id == null || id === '') return '';
  const s = String(id);
  if (s === 'new') return 'new';
  try {
    return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  } catch {
    return s;
  }
}

export function decodeId(opaque: string | null | undefined): string {
  if (!opaque) return '';
  if (opaque === 'new') return 'new';
  if (
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(opaque)
  )
    return opaque;
  // Numeric ids (legacy mock products) — pass through.
  if (/^\d+$/.test(opaque)) return opaque;
  try {
    const b64 = opaque.replace(/-/g, '+').replace(/_/g, '/');
    const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
    return atob(padded);
  } catch {
    return opaque;
  }
}
